export const AD_COMPLETE = 'ad-complete';
export const AD_START = 'ad-start';
export const USER_INTERACTION = 'user-interaction';
export const VIDEO_BUFFER = 'video-buffer';
export const VIDEO_COMPLETE = 'video-complete';
export const VIDEO_ENDED = 'video-ended';
export const VIDEO_FIFTY = 'video-fifty';
export const VIDEO_MIDROLL_COMPLETE = 'video-midroll-complete';
export const VIDEO_MIDROLL_START = 'video-midroll-start';
export const VIDEO_PAUSE = 'video-pause';
export const VIDEO_POSTROLL_COMPLETE = 'video-postroll-complete';
export const VIDEO_POSTROLL_START = 'video-postroll-start';
export const VIDEO_PREROLL = 'video-preroll';
export const VIDEO_PROGRESS = 'video-progress';
export const VIDEO_START = 'video-start';


// WEBPACK FOOTER //
// ./src/tracking/ADBPEventType.js